import type { BaseQueue } from '../../../api/types/common';

type Group = {
  name: string;
  queueStep: number;
  queueRole: 'signer' | 'acceptor';
  users: {
    email: string | null;
    signMethod: string;
    identityProvider: string | null;
    canEdit: boolean;
    phoneNumber: string | null;
    invitation: {
      message: string | null;
    };
  }[];
};

const getUserIdentifier = (user: {
  email: string | null;
  phone?: string | null;
  phoneNumber?: string | null;
}): string | null => {
  if (user.email) return user.email.toLowerCase();
  const phone = user.phone ?? user.phoneNumber;
  if (phone) return phone;
  return null;
};

export const getUsersDocumentIdByGroup = (
  queue: BaseQueue,
  group: Group,
): string[] => {
  const result: string[] = [];
  const groupIdentifiers = group.users
    .map(user => getUserIdentifier(user))
    .filter(Boolean) as string[];

  const step = (group.queueRole === 'signer' ? queue.signers : queue.acceptors)[
    group.queueStep - 1
  ];

  step.queue.forEach(user => {
    const identifier = getUserIdentifier(user.user);
    if (identifier && groupIdentifiers.includes(identifier)) {
      result.push(user.id);
    }
  });

  return result;
};
